import ProfileComponent from './Profile';

export const Profile = ProfileComponent;